// @flow
import React from 'react';
import { get, isEmpty } from 'lodash';

import { ICONS } from 'Components/utils/icon/icons';
import { pluralizeLabel } from 'Components/utils/trips-summary/TripsSummaryUtils';

import { TravelDetail } from 'Components/widgets/travel-details/travel-detail/TravelDetail.jsx';

type Props = {
  adults: {
    number: number,
    labels: {
      for: string,
      label_1: string,
      label_n: string,
    },
  },
  children: {
    number: number,
    labels: {
      and: string,
      label_1: string,
      label_n: string,
    },
  },
};

function getAdultsLabel({ number, labels = {} }) {
  const pluralizedLabel = pluralizeLabel(labels.label_1, labels.label_n, number);
  return `${number} ${pluralizedLabel}`;
}

function getChildrenProps({ number, labels = {} }) {
  const pluralizedLabel = pluralizeLabel(labels.label_1, labels.label_n, number);
  return number && !isEmpty(labels)
    ? {
        text2: labels.and,
        highlightText2: `${number} ${pluralizedLabel}`,
      }
    : null;
}

export default function ParticipantsTravelDetails({ adults, children }: Props) {
  return get(adults, 'number', false) && !isEmpty(adults.labels) ? (
    <TravelDetail
      infos={{
        text1: get(adults, 'labels.for'),
        highlightText1: getAdultsLabel(adults),
        ...getChildrenProps(children),
      }}
      icon={ICONS.USERS}
    />
  ) : null;
}
